import produce from 'immer'
import { assign, findIndex } from 'lodash'

import { areSameValue } from '../../../core/utils'

import {
  CREATE_PRIORITY_TASK,
  DELETE_PRIORITY_TASK,
  FETCH_PRIORITY_TASKS,
  UPDATE_PRIORITY_TASK,
} from '../action-types'
import { PRIORITY_TASKS_INITIAL_STATE } from '../initial-states'

const priorityTasksReducer = (state = PRIORITY_TASKS_INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_PRIORITY_TASKS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          data: {},
        }),
      )

    case FETCH_PRIORITY_TASKS.COMPLETE:
      return produce(state, nextState => {
        const results = action.payload.data.priorityTasks

        return assign(nextState, {
          isLoading: false,
          error: undefined,
          data: results,
        })
      })

    case FETCH_PRIORITY_TASKS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error.message,
          data: {},
        }),
      )

    case CREATE_PRIORITY_TASK.START:
      return produce(state, nextState =>
        assign(nextState, {
          isCreateLoading: true,
          createError: undefined,
        }),
      )

    case CREATE_PRIORITY_TASK.COMPLETE:
      return produce(state, nextState => {
        assign(nextState, {
          isCreateLoading: false,
          createError: undefined,
        })
      })

    case CREATE_PRIORITY_TASK.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isCreateLoading: false,
          createError: action.error.message,
        }),
      )

    case FETCH_PRIORITY_TASKS.CLEANUP:
      return { ...PRIORITY_TASKS_INITIAL_STATE }

    case DELETE_PRIORITY_TASK.START:
      return produce(state, nextState => {
        const index = findIndex(state?.data?.result, ({ id }) =>
          areSameValue(id, action.payload.id),
        )

        assign(nextState.data?.result[index], {
          isLoading: true,
          error: undefined,
        })
      })

    case DELETE_PRIORITY_TASK.COMPLETE:
      return produce(state, nextState => {
        const index = findIndex(state?.data?.result, ({ id }) =>
          areSameValue(id, action.payload.variables.id),
        )

        nextState.data?.result?.splice(index, 1)
      })

    case DELETE_PRIORITY_TASK.FAIL:
      return produce(state, nextState => {
        const index = findIndex(state?.data?.result, ({ id }) =>
          areSameValue(id, action.payload.id),
        )

        assign(nextState.data?.result[index], {
          isLoading: false,
          error: action.error.message,
        })
      })

    case UPDATE_PRIORITY_TASK.COMPLETE:
      return produce(state, nextState => {
        const { updatePriorityTask: priorityTask } = action.payload.data
        const index = findIndex(state?.data?.result, ({ id }) =>
          areSameValue(id, action.payload.variables.id),
        )

        assign(nextState.data?.result[index], {
          ...priorityTask,
        })
      })

    default:
      return state
  }
}

export default priorityTasksReducer
